/**
 * Where one concept lives.
 *
 * A module of its own because half the app links to a brief - the bell, the
 * library, the board, the review queue - and none of those should have to
 * import a card component to learn how a URL is spelled.
 */
import { presentationPath, type BriefPresentation } from "@scandi/shared";

export function briefPath(ref: string): string {
  return `/pipeline/b/${encodeURIComponent(ref)}`;
}

/**
 * Where a brief's deck lives.
 *
 * Two kinds of deck arrive on the same field. One we host: the strategist's
 * agent published it through the write API, it has a row and a slug, and it is
 * served from `/p/<slug>/` behind the same sign-in as the rest of the portal.
 * The other is a link somebody pasted at a deck hosted elsewhere, from before
 * we hosted any. The slug wins when there is one, so a brief that was
 * re-published to our own origin stops pointing at whatever it used to.
 *
 * The server assembles `url` the same way; recomputing it here costs nothing
 * and means a summary that arrives from an older build - one that fills the
 * slug but not the URL - still opens.
 */
export function deckUrl(presentation: BriefPresentation | null | undefined): string | null {
  if (!presentation) return null;
  if (presentation.slug) return presentationPath(presentation.slug);
  return presentation.url;
}
